export default "__VITE_ASSET__YB0vIC5X__"